import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PioneerCardModal } from "./Modals";

export default function Footer({ show = true }) {
  const [pioneerCardOpen, setPioneerCardOpen] = useState(false);

  return (
    <>
      <footer className={`xs-footer ${show ? "show" : ""}`} data-testid="site-footer">
        <div className="xs-footer-copy">
          copyright © 2026 xaelserpent.com | all rights reserved |{" "}
          <Link to="/legal">legal</Link> |{" "}
          <a href="https://x.com/danRydr" target="_blank" rel="noopener noreferrer">
            𝕏 danRydr
          </a>
        </div>
        {/* Footer-only builder/template credit. Deliberately not mounted anywhere
            else (hero, Branding, Admin, post pages, overlays) so a reused
            template can drop or replace this credit without touching the rest
            of the site. */}
        <button
          className="xs-pioneer-card"
          type="button"
          onClick={() => setPioneerCardOpen(true)}
          aria-label="Open xaelserpent contact card"
          data-testid="pioneer-card"
        >
          <img src="/pioneercard.png" alt="" loading="lazy" />
        </button>
      </footer>
      {pioneerCardOpen && <PioneerCardModal onClose={() => setPioneerCardOpen(false)} />}
    </>
  );
}